import store_examinations from './store_examinations'

export default {

  index() {
    store_examinations.index()
  }

}